import React from 'react'
import { useSelector } from 'react-redux'

import GAServiceBase from '../Services/GoogleAnalytics'

function GoogleAnalytics(){
    const model = useSelector(state => state.site.model)

    const icon = (model?.siteForm?.attr?.accounts?.ga?.tokenId.includes("ga4:") && 
        model?.siteForm?.attr?.accounts?.ga?.propertyId) || (!model?.siteForm?.attr?.accounts?.ga?.tokenId.includes("ga4:") && 
        model?.siteForm?.attr?.accounts?.ga?.viewId) ? <i class="fas fa-check-circle text-success fa-1-5"></i> : null
    return <>
        <div class="d-flex justify-content-center align-items-center flex-sm-row flex-column">
            <GAServiceBase />
            {/* <div className="ml-4 d-none d-sm-block">
                <div className="text-center mb-4" style={{width: "100px"}}>
                    <ServiceCard 
                        {...serviceMap.ga} 
                        active={true}
                        overrideIcon={icon}
                    />
                </div>
            </div> */}
        </div>
        {/* <div className="d-flex justify-content-center d-sm-none align-items-stretch">
            <div style={{width: "100px"}}>
                <ServiceCard 
                    {...serviceMap.ga} 
                    active={true}
                    overrideIcon={icon}
                />
            </div>
        </div> */}
    </>
}

export default GoogleAnalytics